import React, { useState, useEffect, useRef, useGlobal, useCallback, useMemo, memo as memo$1, Fragment as Fragment$1, useDispatch, useLayoutEffect, setGlobal, addReducer } from 'reactn';
import styled, { keyframes, ThemeProvider } from 'styled-components';
import color from 'color';
import { toArray } from 'react-emoji-render';
import React$1, { memo, useState as useState$1, useRef as useRef$1, useEffect as useEffect$1, Fragment as Fragment$2 } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import OutsideClickHandler from 'react-outside-click-handler';
import EmojiPicker from 'emoji-picker-react';
import autosize from 'autosize';
import formatRelative from 'date-fns/formatRelative';
import parseISO from 'date-fns/parseISO';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import format from 'date-fns/format';
import Linkify from 'react-linkify';
import ModalImage from 'react-modal-image';
import InfiniteScroll$1 from 'react-infinite-scroller';
import * as defaultDateFNSLocale from 'date-fns/locale';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function isAsyncMode(a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function isContextConsumer(a) {
  return z(a) === k;
};

var isContextProvider = function isContextProvider(a) {
  return z(a) === h;
};

var isElement = function isElement(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function isForwardRef(a) {
  return z(a) === n;
};

var isFragment = function isFragment(a) {
  return z(a) === e;
};

var isLazy = function isLazy(a) {
  return z(a) === t;
};

var isMemo = function isMemo(a) {
  return z(a) === r;
};

var isPortal = function isPortal(a) {
  return z(a) === d;
};

var isProfiler = function isProfiler(a) {
  return z(a) === g;
};

var isStrictMode = function isStrictMode(a) {
  return z(a) === f;
};

var isSuspense = function isSuspense(a) {
  return z(a) === p;
};

var isValidElementType = function isValidElementType(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }

      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var COLORS = {
  offwhite: '#EEE7DF',
  green: '#002E3A',
  white: '#FFFFFF',
  pastelRed: '#ff6961',
  orange: '#f19745',
  blue: '#1f6984',
  lightBlue: '#307387',
  blueishWhite: 'rgba(233,240,242,0.5)'
};

function _templateObject49() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  text-align: center;\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: black;\n  text-align: center;\n"]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: 15px;\n  width: 49%;\n  text-align: center;\n  padding: 15px 0px;\n"]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  padding: 0px 20px;\n  justify-content: space-between;\n"]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  position: sticky;\n  bottom: 0;\n  text-align: center;\n  width: fit-content;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  cursor: pointer;\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteralLoose(["\n  background-image: url(", ");\n  background-repeat: no-repeat;\n  width: 30px;\n  height: 30px;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  border-radius: 30px;\n  z-index: 1001;\n  background-size: 50%;\n  background-position: center;\n  cursor: pointer;\n  @media only screen and (max-width: 767px) {\n    right: 0;\n  }\n"]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: white;\n  border-radius: 20px;\n  max-height: 90vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-box-shadow: 10px 10px 5px -8px rgba(0, 0, 0, 0.16);\n  -moz-box-shadow: 10px 10px 5px -8px rgba(0, 0, 0, 0.16);\n  box-shadow: 10px 10px 5px -8px rgba(0, 0, 0, 0.16);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 70px;\n  left: 10px;\n\n  visibility: ", ";\n  .emoji-picker .emoji {\n    padding: 15px !important;\n  }\n"]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteralLoose(["\nmargin-", ": auto;\n"]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: 40px 0;\n  position: sticky;\n"]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: initial;\n  justify-content: start;\n  align-items: center;\n\n  margin-top: 30px;\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width:", ";\n  margin-", ": 10px;\n  border-radius: 100%;\n  object-fit: cover;\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteralLoose(["\n  color: #8c8c8c;\n  font-size: 12px;\n  font-weight: normal;\n"]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  background-image: url('", "');\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  & {\n    .empty-text {\n      font-weight: bold;\n      background-color: white;\n      padding: 10px 20px;\n      border-radius: 20px;\n      display: block;\n      box-shadow: 0px 0 5px 0 rgba(0, 0, 0, 0.3);\n\n      cursor: pointer;\n\n      transition: all 0.3s ease;\n\n      &:hover,\n      &:focus {\n        transform: scale(1.05);\n      }\n\n      @media only screen and (max-width: 768px) {\n        font-size: 13px;\n      }\n    }\n  }\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n  margin-bottom: -15px;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: ", ";\n  margin: 5px 0;\n\n  padding: 0 50px;\n\n  @media only screen and (max-width: 1199px) {\n    padding: 0 2px;\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: white;\n  border-radius: 20px;\n  width: 20px;\n  height: 20px;\n  margin-", ": 10px;\n\n  justify-content: center;\n  align-items: center;\n  display: flex;\n\n  position: absolute;\n  ", ";\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 60%;\n\n  @media only screen and (max-width: 1199px) {\n    max-width: none;\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: bold;\n  color: #0e1111;\n  @media only screen and (max-width: 768px) {\n    font-size: 13px;\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteralLoose(["\n  display: ", ";\n  font-family: inherit;\n  font-size: 12px;\n  color: #afafaf;\n  text-align: center;\n  font-weight: bold;\n  color: #0e1111;\n  padding: 5px 10px;\n  width: fit-content;\n  background-color: white;\n  margin: 0 auto;\n  border-radius: 10px;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: inherit;\n  font-size: 13px;\n  color: #34495e;\n  white-space: nowrap;\n\n  text-align: unset;\n  margin: 0 10px;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 11px;\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: inherit;\n  padding: 10px 20px;\n  border-radius: 5px;\n  margin: 0;\n  text-align: left;\n  word-break: break-word;\n  background-color: ", ";\n\n  background-image: ", ";\n  color: ", ";\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08) !important;\n\n  .small-image {\n    max-width: 200px !important;\n    max-height: 200px !important;\n  }\n\n  a {\n    color: #1890ff;\n    text-decoration: none;\n    background-color: transparent;\n    outline: none;\n    cursor: pointer;\n  }\n\n  @media only screen and (max-width: 768px) {\n    font-size: 13px;\n\n    .small-image {\n      max-width: 100px !important;\n      max-height: 100px !important;\n    }\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  text-align: ", ";\n  flex-direction: ", ";\n  position: relative;\n  word-break: break-word;\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  -webkit-flex: 1 1 auto;\n  overflow-y: auto;\n  min-height: 0px;\n  padding: 40px;\n  position: relative;\n  padding-top: 80px;\n  height: 100%;\n  wdith: 100%;\n\n  background-image: url('", "');\n\n  /* width */\n  &::-webkit-scrollbar {\n    width: 7px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #ededed;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose(["\n  background-image: linear-gradient(\n    120deg,\n    ", " 0%,\n    ", "\n      50%\n  );\n  ", ";\n\n  cursor: ", ";\n  margin: ", ";\n  padding: 10px 15px;\n  color: white;\n  border-radius: 5px;\n  box-shadow: 0 0 5px\n    ", ";\n  transition: 0.3s all ease;\n  max-height: 40px;\n  width: auto;\n  ", "\n  font-weight: bold;\n\n  &:hover,\n  &:focus {\n    ", "\n  }\n\n  & {\n    img {\n      max-height: 20px;\n      width: 20px;\n      object-fit: contain;\n    }\n  }\n  @media only screen and (max-width: 768px) {\n    padding: 5px 5px;\n    font-size: 1em;\n    margin: 5px;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: relative;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 10px;\n  padding: ", "\n  width: 100%;\n  outline: none;\n  border: none;\n  font-size: 100%;\n  color: #0e1111;\n  overflow:auto;\n  resize:none;\n  margin-top:10px;\n  margin-bottom:10px;\n  padding-top:2px;\n  border: 2px solid ", ";\n\n  transition: all 0.3s ease;\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 0 5px ", ");\n  }\n\n  @media only screen and (max-width: 768px) {\n    font-size: 16px;\n    margin-top:5px;\n    margin-bottom:0px;\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  width: 80%;\n  height: 80%;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 100%;\n  //min-height: 70px;\n  height: fit-content;\n  display: flex;\n  box-sizing: border-box;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 100%;\n  align-items: center;\n\n  display: flex;\n\n  min-height: 60px;\n\n  padding: 20px;\n  box-sizing: border-box;\n  box-shadow: 0px 0 3px 0 rgba(0, 0, 0, 0.2);\n  z-index: 1;\n\n  & {\n    span {\n      font-size: 13px;\n      .typing-name {\n        font-weight: bold !important;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 768px) {\n    padding: 10px;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: inherit;\n  font-size: 12px;\n  color: gray;\n  margin: 0;\n  margin-top: 5px;\n\n  display: inline-block;\n  overflow: hidden;\n  display: inline-block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 200px;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 40px;\n  height: 40px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: inherit;\n  font-weight: bold;\n  font-size: 14px;\n  margin: 0;\n  @media only screen and (max-width: 768px) {\n    max-width: 17em;\n  }\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  cursor: pointer;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  font-size: 16px;\n  border: none;\n  border-radius: 5px;\n  padding: 0 20px;\n  outline: none;\n\n  transition: all 0.3s ease;\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 0 5px\n      ", ";\n    padding-left: 30px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0px 20px;\n  label {\n    display: none !important;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 20px 20px;\n  height: 80px;\n  box-sizing: border-box;\n  display: flex;\n\n  .search-button {\n    margin: 0;\n    margin-", ":  20px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  background-color: ", ";\n  padding: 20px;\n\n  border-bottom: 1px #d3d3d3 solid;\n\n  transition: all 0.2s ease-in-out;\n  &:hover,\n  &:focus {\n    box-sizing: border-box;\n    background-color: #e1e1e1;\n    padding-left: 25px;\n  }\n\n  overflow: hidden;\n  position: relative;\n\n  .user-image {\n    height: 50px;\n    width: 50px;\n    border-radius: 100%;\n    background-color: #eeeeee;\n    margin-", ":  15px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-weight: bold;\n    font-size: 12px;\n    color: ", ");\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  overflow-y: hidden;\n  overflow-x: hidden;\n  height: 100%;\n  box-sizing: border-box;\n  padding-right: -15px;\n\n  @media only screen and (max-width: 768px) {\n    max-height: calc(100vh - 200px);\n  }\n\n  &:hover {\n    overflow-y: scroll;\n  }\n\n  @media only screen and (max-width: 768px) {\n    overflow: auto;\n  }\n\n  /* width */\n  &::-webkit-scrollbar {\n    width: 7px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #ededed;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 400px;\n  max-width: 400px;\n\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 0 3px 0 rgba(0, 0, 0, 0.2);\n\n  z-index: 2;\n  background-color: #f1f1f1;\n  position: relative;\n\n  transition: all 0.3s ease;\n  left: 0;\n\n  @media only screen and (max-width: 768px) {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    height: unset;\n    transition: left 0.3s ease;\n\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n\n  width: 100%;\n  margin: auto;\n  border-radius: 10px;\n\n  position: relative;\n  transition: all 0.3s ease;\n\n  * {\n    font-family: 'Poppins', sans-serif;\n  }\n\n  .typing-indicator {\n    color: ", ";\n    font-size: 12px;\n    font-weight bold;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  transition: all 0.3s ease;\n\n  @media only screen and (max-width: 768px) {\n    font-size: 16px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BodyContainer = styled.div(_templateObject());
var BodyWrapper = styled.div(_templateObject2());
var ChatWrapper = styled.div(_templateObject3(), function (_ref) {
  var primaryColor = _ref.theme.primaryColor;
  return primaryColor;
});
var SidebarWrapper = styled.div(_templateObject4(), function (_ref2) {
  var state = _ref2.state;
  return state === 'hidden' ? "\n          left: -100%;\n        " : '';
});
var ContactsListWrapper = styled.div(_templateObject5(), function (_ref3) {
  var primaryColor = _ref3.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (_ref4) {
  var primaryColor = _ref4.theme.primaryColor;
  return primaryColor;
});
var ContactWrapper = styled.div(_templateObject6(), function (props) {
  return props.selected ? '#e1e1e1' : '#f1f1f1';
}, function (_ref5) {
  var direction = _ref5.theme.direction;
  return direction === 'ltr' ? 'right' : 'left';
}, function (_ref6) {
  var primaryColor = _ref6.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
});
var SearchWrapper = styled.div(_templateObject7(), function (_ref7) {
  var direction = _ref7.theme.direction;
  return direction === 'rtl' ? 'right' : 'left';
});
var FiltersWrapper = styled.div(_templateObject8());
var Search = styled.input(_templateObject9(), function (_ref8) {
  var primaryColor = _ref8.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
});
var ContactData = styled.div(_templateObject10());
var ContactName = styled.span(_templateObject11());
var ContactImage = styled.img(_templateObject12());
var ImageNameWrapper = styled.div(_templateObject13());
var ContactMessage = styled.span(_templateObject14());
var HeaderWrapper = styled.div(_templateObject15(), COLORS.white);
var FooterWrapper = styled.div(_templateObject16(), COLORS.white);
var FooterInputWrapper = styled.div(_templateObject17());
var ChatInput = styled.input(_templateObject18(), function (_ref9) {
  var inputPadding = _ref9.theme.inputPadding;
  return (inputPadding || '12px') + " 10px;";
}, function (_ref10) {
  var primaryColor = _ref10.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (_ref11) {
  var primaryColor = _ref11.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
});
var SearchBar = styled.div(_templateObject19());
var CallChatButton = styled.button(_templateObject20());
var FooterButton = styled.div(_templateObject21(), function (_ref12) {
  var primaryColor = _ref12.theme.primaryColor;
  return primaryColor;
}, function (_ref13) {
  var primaryColor = _ref13.theme.primaryColor;
  return color(primaryColor).fade(0.2).rgb().string();
}, function (props) {
  return props.disabled && 'background: linear-gradient(360deg, #dee1e1 10%, #f4f4f4 360%)';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.smallMargin ? '0px 10px' : '0px 20px';
}, function (_ref14) {
  var primaryColor = _ref14.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (props) {
  return props.fixedHeight && 'height:20px;';
}, function (props) {
  return !props.disabled && 'box-shadow: none;';
});
var MessagesWrapper = styled.div(_templateObject22(), function (_ref15) {
  var background = _ref15.theme.background;
  return background;
}, function (_ref16) {
  var primaryColor = _ref16.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (_ref17) {
  var primaryColor = _ref17.theme.primaryColor;
  return primaryColor;
});
var MessageWrapper = styled.div(_templateObject23(), function (props) {
  return props.orientation === 'sender' ? 'right' : 'left';
}, function (props) {
  return props.orientation === 'sender' ? 'row-reverse' : 'row';
});
var MessageData = styled.div(_templateObject24(), function (_ref18) {
  var orientation = _ref18.orientation;
  return orientation === 'sender' ? '' : 'white';
}, function (_ref19) {
  var orientation = _ref19.orientation,
      primaryColor = _ref19.theme.primaryColor;
  return orientation === 'sender' ? "linear-gradient(60deg, " + primaryColor + " 0%, " + color(primaryColor).fade(0.2).rgb().string() + " 50%)" : 'white';
}, function (props) {
  return props.orientation === 'sender' ? COLORS.white : '#0e1111';
});
var MessageDate = styled.p(_templateObject25());
var MessageDateTitle = styled.p(_templateObject26(), function (props) {
  return props.hide && 'none';
});
var MessageName = styled.span(_templateObject27());
var MessageDataWrapper = styled.div(_templateObject28());
var FileInput = styled.input(_templateObject29());
var UnreadDot = styled.div(_templateObject30(), function (_ref20) {
  var primaryColor = _ref20.theme.primaryColor;
  return primaryColor;
}, function (_ref21) {
  var direction = _ref21.theme.direction;
  return direction === 'ltr' ? 'left' : 'right';
}, function (_ref22) {
  var direction = _ref22.theme.direction;
  return direction === 'ltr' ? 'right: 10px' : 'left: 30px';
});
var MessageRowWrapper = styled.div(_templateObject31(), function (props) {
  return props.orientation === 'sender' ? 'row-reverse' : 'row';
});
var Seperator = styled.div(_templateObject32());
var EmptyHandlerWrapper = styled.div(_templateObject33(), function (_ref23) {
  var background = _ref23.theme.background;
  return background;
});
var MessageSender = styled.span(_templateObject34());
var SenderImage = styled.img(_templateObject35(), function (props) {
  return props.isConversationImage ? '50px' : '30px';
}, function (props) {
  return props.isConversationImage ? '50px' : '30px';
}, function (_ref24) {
  var direction = _ref24.theme.direction;
  return direction === 'rtl' ? 'left' : 'right';
});
var SenderInfo = styled.div(_templateObject36());
var DateTitleWrapper = styled.div(_templateObject37());
var BroadcastWrapper = styled.div(_templateObject38(), function (_ref25) {
  var direction = _ref25.theme.direction;
  return direction === 'ltr' ? 'left' : 'right';
});
var EmojiWrapper = styled.div(_templateObject39(), function (props) {
  return props.active ? 'visible' : 'hidden';
});
var GenericModalWrapper = styled.div(_templateObject40(), function (props) {
  return props.isVisible ? 'flex' : 'none';
});
var ChildWrapper = styled.div(_templateObject41());
var CloseButton = styled.div(_templateObject42(), function (props) {
  return "\"" + props.icon + "\"";
}, COLORS.pastelRed);
var ConversationTiming = styled.div(_templateObject43());
var DropDownToChat = styled.div(_templateObject44(), function (props) {
  return props.show ? '' : 'none';
});
var ImageNameSearchWrapper = styled.div(_templateObject45());
var ArchivedOpenWrapper = styled.div(_templateObject46());
var OpenArchivedButton = styled.div(_templateObject47(), function (props) {
  return props.selected ? props.activeColor || 'black' : props.dimmedColor || 'white';
});
var NoPublicKey = styled.div(_templateObject48());
var WrongDevice = styled.div(_templateObject49());

var useMedia = function useMedia(query) {
  var _useState = useState(window.matchMedia(query).matches),
      matches = _useState[0],
      setMatches = _useState[1];

  useEffect(function () {
    var media = window.matchMedia(query);
    if (media.matches !== matches) setMatches(media.matches);

    var listener = function listener() {
      return setMatches(media.matches);
    };

    media.addEventListener('change', listener);
    return function () {
      return media.removeEventListener('change', listener);
    };
  }, [matches, query]);
  return matches;
};

var useFileReader = function useFileReader(onMessageHandler) {
  var onChangeFile = function onChangeFile(event) {
    var files = event.target.files;
    Object.entries(files).forEach(function (_ref) {
      var file = _ref[1];
      onMessageHandler({
        file: file
      });
    });
    event.target.value = null;
    event.target.files = null;
  };

  return [onChangeFile];
};

var useKeyboard = function useKeyboard(key, callback) {
  useEffect(function () {
    var handler = function handler(event) {
      if (event.key === key) callback(event);
    };

    window.addEventListener('keydown', handler);
    return function () {
      window.removeEventListener('keydown', handler);
    };
  }, [callback, key]);
};

var useSearch = function useSearch(_ref2) {
  var _messageSearched$curr;

  var id = _ref2.id,
      listRef = _ref2.listRef;
  var ref = useRef();

  var _useGlobal = useGlobal('currentMessageIndex'),
      currentMessageIndex = _useGlobal[0];

  var _useGlobal2 = useGlobal('messageSearched'),
      messageSearched = _useGlobal2[0];

  var isMarked = (messageSearched === null || messageSearched === void 0 ? void 0 : (_messageSearched$curr = messageSearched[currentMessageIndex]) === null || _messageSearched$curr === void 0 ? void 0 : _messageSearched$curr.id) === id;
  useEffect(function () {
    var _messageSearched$curr2;

    if ((messageSearched === null || messageSearched === void 0 ? void 0 : (_messageSearched$curr2 = messageSearched[currentMessageIndex]) === null || _messageSearched$curr2 === void 0 ? void 0 : _messageSearched$curr2.id) === id) {
      listRef.listRef.scrollTo({
        top: ref.current.offsetTop,
        behavior: 'smooth'
      });
    }
  }, [messageSearched, currentMessageIndex]);
  return {
    isMarked: isMarked,
    ref: ref
  };
};

var useSearchBar = function useSearchBar(_ref3) {
  _objectDestructuringEmpty(_ref3);

  var _useState2 = useState(false),
      searching = _useState2[0],
      setSearching = _useState2[1];

  var _useGlobal3 = useGlobal('setMessageFound'),
      setMessageFound = _useGlobal3[0];

  var _useGlobal4 = useGlobal('handleChangeCurrentMessageIndex'),
      handleChangeCurrentMessageIndex = _useGlobal4[0];

  var _useGlobal5 = useGlobal('currentMessageIndex'),
      currentMessageIndex = _useGlobal5[0];

  var _useGlobal6 = useGlobal('onMessagesSearch'),
      onMessagesSearch = _useGlobal6[0];

  var handleIncrementIndex = function handleIncrementIndex() {
    handleChangeCurrentMessageIndex(currentMessageIndex + 1);
  };

  var handleDecrementIndex = function handleDecrementIndex() {
    handleChangeCurrentMessageIndex(currentMessageIndex - 1);
  };

  var handleSearch = function handleSearch(e) {
    if (e.target.value) {
      setSearching(true);
    } else {
      setSearching(false);
      handleChangeCurrentMessageIndex(0);
    }

    var result = onMessagesSearch === null || onMessagesSearch === void 0 ? void 0 : onMessagesSearch(e.target.value);
    setMessageFound(result);
  };

  return {
    handleDecrementIndex: handleDecrementIndex,
    handleIncrementIndex: handleIncrementIndex,
    handleSearch: handleSearch,
    searching: searching
  };
};

var parseEmojis = function parseEmojis(value) {
  var emojisArray = toArray(value);
  var newValue = emojisArray.reduce(function (previous, current) {
    if (typeof current === 'string') {
      return previous + current;
    }

    return previous + current.props.children;
  }, '');
  return newValue;
};

var useMessage = function useMessage(id) {
  var _useGlobal = useGlobal('messages'),
      message = _useGlobal[0].entities[id];

  return message;
};

var useMessageCallback = function useMessageCallback() {
  var _useGlobal2 = useGlobal('messages'),
      entities = _useGlobal2[0].entities;

  var getMessage = useCallback(function (id) {
    return entities[id];
  }, [entities]);
  return getMessage;
};

var useConversation = function useConversation(id) {
  var _useGlobal = useGlobal('conversations'),
      conversation = _useGlobal[0].entities[id];

  return conversation;
};
/** Used for built-in method references. */


var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
  return value === proto;
}

var _isPrototype = isPrototype;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;
/** Used for built-in method references. */

var objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$1.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}

var _baseKeys = baseKeys;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;
/** Built-in value references. */

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;
/** Used for built-in method references. */

var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$2.toString;
/** Built-in value references. */

var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$2.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }

  return result;
}

var _getRawTag = getRawTag;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$3.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;
/** `Object#toString` result references. */

var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}

var _baseGetTag = baseGetTag;
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;
/** `Object#toString` result references. */

var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = _baseGetTag(value);

  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;
/** Used to detect overreaching core-js shims. */

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

var _isMasked = isMasked;
/** Used for built-in method references. */

var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}

var _toSource = toSource;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto$1 = Function.prototype,
    objectProto$4 = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }

  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */

function getNative(object, key) {
  var value = _getValue(object, key);

  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;
/* Built-in method references that are verified to be native. */

var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;
/* Built-in method references that are verified to be native. */

var Map = _getNative(_root, 'Map');

var _Map = Map;
/* Built-in method references that are verified to be native. */

var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;
/* Built-in method references that are verified to be native. */

var Set = _getNative(_root, 'Set');

var _Set = Set;
/* Built-in method references that are verified to be native. */

var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;
/** `Object#toString` result references. */

var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */


var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag || _Map && getTag(new _Map()) != mapTag || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag || _WeakMap && getTag(new _WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;

        case mapCtorString:
          return mapTag;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag;

        case weakMapCtorString:
          return weakMapTag;
      }
    }

    return result;
  };
}

var _getTag = getTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
var isArguments_1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray_1 = isArray;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */

function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Built-in value references. */

  var Buffer = moduleExports ? _root.Buffer : undefined;
  /* Built-in method references for those with the same name as other `lodash` methods. */

  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */

  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});
/** `Object#toString` result references. */

var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    weakMapTag$1 = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;
  /** Detect free variable `module`. */

  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  /** Detect the popular CommonJS extension `module.exports`. */

  var moduleExports = freeModule && freeModule.exports === freeExports;
  /** Detect free variable `process` from Node.js. */

  var freeProcess = moduleExports && _freeGlobal.process;
  /** Used to access faster Node.js helpers. */

  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      } // Legacy `process.binding('util')` for Node.js < 10.


      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  module.exports = nodeUtil;
});
/* Node.js helper references. */


var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;
/** `Object#toString` result references. */

var mapTag$2 = '[object Map]',
    setTag$2 = '[object Set]';
/** Used for built-in method references. */

var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */

function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (isArrayLike_1(value) && (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
    return !value.length;
  }

  var tag = _getTag(value);

  if (tag == mapTag$2 || tag == setTag$2) {
    return !value.size;
  }

  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }

  for (var key in value) {
    if (hasOwnProperty$5.call(value, key)) {
      return false;
    }
  }

  return true;
}

var isEmpty_1 = isEmpty;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }

  end = end > length ? length : end;

  if (end < 0) {
    end += length;
  }

  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result = Array(length);

  while (++index < length) {
    result[index] = array[index + start];
  }

  return result;
}

var _baseSlice = baseSlice;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol;
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */

var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol_1(value)) {
    return NAN;
  }

  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber;
/** Used as references for various `Number` constants. */

var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */

function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }

  value = toNumber_1(value);

  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }

  return value === value ? value : 0;
}

var toFinite_1 = toFinite;
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */

function toInteger(value) {
  var result = toFinite_1(value),
      remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}

var toInteger_1 = toInteger;
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */

function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }

  n = guard || n === undefined ? 1 : toInteger_1(n);
  return _baseSlice(array, 0, n < 0 ? 0 : n);
}

var take_1 = take;
var TypingIndicator = memo(function (_ref) {
  var conversation = _ref.conversation;

  var _useConversation = useConversation(conversation),
      typing = _useConversation.typing;

  var _useGlobal = useGlobal('text'),
      text = _useGlobal[0];

  var suffix = useMemo(function () {
    if (typing.length === 1) return /*#__PURE__*/React.createElement("span", null, " ", text.isTyping);else return /*#__PURE__*/React.createElement("span", null, " ", text.areTyping);
  }, [typing.length]);
  if (isEmpty_1(typing)) return null;
  return /*#__PURE__*/React.createElement("span", {
    className: "typing-indicator"
  }, take_1(typing, 3).map(function (id, index) {
    return /*#__PURE__*/React.createElement(TypingUser, {
      key: id,
      id: id,
      index: index
    });
  }), suffix);
});

var TypingUser = function TypingUser(_ref2) {
  var id = _ref2.id;

  var _useGlobal2 = useGlobal('senderName'),
      senderName = _useGlobal2[0];

  var _useGlobal3 = useGlobal('users'),
      UserEntities = _useGlobal3[0].entities;

  return /*#__PURE__*/React.createElement("span", null, senderName(id, UserEntities));
};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */


function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

var Conversation = function Conversation(_ref) {
  var id = _ref.id;

  var _useGlobal = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal[0];

  var _useGlobal2 = useGlobal('onConversationClick'),
      onConversationClick = _useGlobal2[0];

  var _useGlobal3 = useGlobal('conversationName'),
      conversationName = _useGlobal3[0];

  var _useGlobal4 = useGlobal('showConversationTiming'),
      showConversationTiming = _useGlobal4[0];

  var _useGlobal5 = useGlobal('conversationTime'),
      conversationTime = _useGlobal5[0];

  var _useGlobal6 = useGlobal('conversationExtraComponent'),
      ExtraComponent = _useGlobal6[0];

  var _useGlobal7 = useGlobal('avatarPlaceHolder'),
      avatarPlaceHolder = _useGlobal7[0];

  var _useGlobal8 = useGlobal('resolveConversationTargetImage'),
      resolveConversationTargetImage = _useGlobal8[0];

  var conversation = useConversation(id);
  var changeSidebarVisibility = useDispatch('SIDEBAR');
  var isSmall = useMedia('(max-width: 768px)');

  var _useGlobal9 = useGlobal('users'),
      UserEntities = _useGlobal9[0].entities;

  var lastMessageId = useMemo(function () {
    return last_1(conversation === null || conversation === void 0 ? void 0 : conversation.messages);
  }, [conversation === null || conversation === void 0 ? void 0 : conversation.messages]);
  var lastMessage = conversation === null || conversation === void 0 ? void 0 : conversation.last_message;
  var onClick = useCallback(function () {
    if (isSmall) changeSidebarVisibility('hidden');
    onConversationClick(id);
  }, [isSmall, conversation, changeSidebarVisibility]);
  var isCurrentlyOpen = useMemo(function () {
    return selectedConversation === id;
  }, [selectedConversation]);
  useEffect(function () {
    if (selectedConversation && selectedConversation == id) onClick();
  }, []);
  var targetImageSource = resolveConversationTargetImage(conversation);
  return !conversation ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement("div", {
    className: "chat-contact-wrapper"
  }, /*#__PURE__*/React.createElement(ContactWrapper, {
    selected: isCurrentlyOpen,
    onClick: onClick,
    className: "contact-wrapper"
  }, /*#__PURE__*/React.createElement(SenderImage, {
    className: "sender-image-conversation",
    isConversationImage: true,
    src: targetImageSource || avatarPlaceHolder
  }), /*#__PURE__*/React.createElement(ContactData, {
    className: "contact-data"
  }, /*#__PURE__*/React.createElement(ContactName, {
    className: "contact-name-conversation"
  }, conversationName(conversation, UserEntities)), !isEmpty_1(conversation.typing) && !isCurrentlyOpen ? /*#__PURE__*/React.createElement(TypingIndicator, {
    conversation: id
  }) : /*#__PURE__*/React.createElement(LastMessage, {
    id: lastMessageId,
    messageBody: lastMessage
  }), conversation.unread_count > 0 ? /*#__PURE__*/React.createElement(UnreadDot, {
    className: "unread-count"
  }, conversation.unread_count) : showConversationTiming && /*#__PURE__*/React.createElement(ConversationTiming, {
    className: "conversation-timing"
  }, conversationTime(conversation)))), /*#__PURE__*/React.createElement(ExtraComponent, {
    selectedConversation: selectedConversation,
    conversation: conversation
  }));
};

var LastMessage = memo$1(function (_ref2) {
  var id = _ref2.id,
      messageBody = _ref2.messageBody;
  var messageBodyById = useMessage(id);
  var message = id ? messageBodyById : messageBody;

  var _useGlobal10 = useGlobal('senderName'),
      senderName = _useGlobal10[0];

  var _useGlobal11 = useGlobal('users'),
      UserEntities = _useGlobal11[0].entities;

  var _useGlobal12 = useGlobal('text'),
      text = _useGlobal12[0];

  if (!message) return /*#__PURE__*/React.createElement("span", {
    className: "first-message"
  }, !text.noMessage && text.firstMessage);
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(ContactMessage, {
    className: "contact-message"
  }, message.attachment ? senderName(message.sender, UserEntities) + " " + text.sentAttachment : parseEmojis(message === null || message === void 0 ? void 0 : message.body)));
});

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    width: 40px;\n    height: 40px;\n\n    position: relative;\n    margin: 20px auto;\n  }\n\n  & {\n    .double-bounce1,\n    .double-bounce2 {\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      background-color: ", ";\n      opacity: 0.6;\n      position: absolute;\n      top: 0;\n      left: 0;\n\n      -webkit-animation: sk-bounce 2s infinite ease-in-out;\n      animation: sk-bounce 2s infinite ease-in-out;\n    }\n\n    .double-bounce2 {\n      -webkit-animation-delay: -1s;\n      animation-delay: -1s;\n    }\n  }\n\n  @-webkit-keyframes sk-bounce {\n    0%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    50% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bounce {\n    0%,\n    100% {\n      transform: scale(0);\n      -webkit-transform: scale(0);\n    }\n    50% {\n      transform: scale(1);\n      -webkit-transform: scale(1);\n    }\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSpinner = styled.div(_templateObject$1(), function (_ref) {
  var primaryColor = _ref.theme.primaryColor;
  return primaryColor;
});

var Spinner = function Spinner() {
  return /*#__PURE__*/React$1.createElement(StyledSpinner, {
    className: "spinner"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "double-bounce1"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "double-bounce2"
  }));
};

var ConversationList = function ConversationList() {
  return /*#__PURE__*/React.createElement(ContactsListWrapper, {
    id: "conversation-list",
    className: "conversation-list"
  }, /*#__PURE__*/React.createElement(WrapperList, null));
};

var WrapperList = React.memo(function () {
  var _useGlobal = useGlobal('conversations'),
      ids = _useGlobal[0].ids;

  var _useGlobal2 = useGlobal('onConversationsPagination'),
      onConversationsPagination = _useGlobal2[0];

  var _useGlobal3 = useGlobal('hasMoreConversations'),
      hasMoreConversations = _useGlobal3[0];

  var _useGlobal4 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal4[0];

  var _useGlobal5 = useGlobal('onConversationClick'),
      onConversationClick = _useGlobal5[0];

  useEffect(function () {
    if (selectedConversation) onConversationClick(selectedConversation);
  }, [selectedConversation]);
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    hasMore: hasMoreConversations,
    dataLength: ids.length,
    next: onConversationsPagination,
    loader: /*#__PURE__*/React.createElement(Spinner, null),
    scrollableTarget: "conversation-list"
  }, /*#__PURE__*/React.createElement(ListRender, null));
});
var ListRender = React.memo(function () {
  var _useGlobal6 = useGlobal('conversations'),
      ids = _useGlobal6[0].ids;

  return ids.map(function (id) {
    return /*#__PURE__*/React.createElement("div", {
      key: id
    }, /*#__PURE__*/React.createElement(Conversation, {
      id: id
    }));
  });
});
var ConversationList$1 = React.memo(ConversationList);

function _templateObject16$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]);

  _templateObject16$1 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n  border-width: 2px;\n  border-color: ", ";\n  border-top-color: ", ";\n  animation: ", " 1s infinite linear;\n  border-radius: 100%;\n  border-style: solid;\n"]);

  _templateObject15$1 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14$1() {
  var data = _taggedTemplateLiteralLoose(["\n  100% {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject14$1 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n"]);

  _templateObject13$1 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 80%;\n  padding: 10px;\n"]);

  _templateObject12$1 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject11$1 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  transform: scale(1.5);\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 80%;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #989898;\n  padding: 10px;\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  max-height: calc(80vh - 350px);\n  min-height: 15em;\n  overflow: overlay;\n  // /* width */\n  &::-webkit-scrollbar {\n    width: 7px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: #ededed;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n    transition: 0.5s all ease;\n  }\n\n  scrollbar-color: ", ";\n  ", ";\n  scrollbar-width: thin;\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: 10px;\n  justify-content: center;\n  // border-bottom: 1px solid #989898;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-left: 24px;\n  margin-right: 24px;\n  cursor: pointer;\n  width: 80px;\n  text-align: center;\n\n  &:hover {\n    color: ", ";\n    transition: color 0.3s ease;\n  }\n  ", "\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  margin-top: 10px;\n  bottom: 0;\n  width: 100%;\n  textarea {\n    height: 50px;\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #989898;\n  background-color: ", ";\n  padding: 16px 24px;\n  border-radius: 5px 5px 0px 0px;\n  span {\n    font-size: 1.5em;\n    font-weight: bold;\n    line-height: 22px;\n    color: white;\n  }\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: 5px;\n  width: 30em;\n  height: fit-content;\n  margin-top: 10px;\n  background-color: ", ";\n  box-shadow: 0px 0 3px 0 rgb(0 0 0 / 20%);\n  @media only screen and (max-width: 768px) {\n    width: 100vw;\n    margin: 3px 5px;\n  }\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  touch-action: none;\n  overflow: hidden;\n  justify-content: center;\n  display: flex;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var ModalContainer = styled.div(_templateObject$2());
var ContentWrapper = styled.div(_templateObject2$1(), COLORS.white);
var Content = styled.div(_templateObject3$1());
var Title = styled.div(_templateObject4$1(), function (_ref) {
  var primaryColor = _ref.theme.primaryColor;
  return primaryColor;
});
var FooterWrapper$1 = styled.div(_templateObject5$1());
var ContactTabTitle = styled.h3(_templateObject6$1(), function (_ref2) {
  var primaryColor = _ref2.theme.primaryColor;
  return primaryColor;
}, function (props) {
  return props.isSelected && "border-bottom: 2px solid " + props.theme.primaryColor;
});
var ContactsWrapper = styled.div(_templateObject7$1());
var ContactsListWrapper$1 = styled.div(_templateObject8$1(), function (_ref3) {
  var primaryColor = _ref3.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (_ref4) {
  var primaryColor = _ref4.theme.primaryColor;
  return primaryColor;
}, function (_ref5) {
  var primaryColor = _ref5.theme.primaryColor;
  return color(primaryColor).fade(0.5).rgb().string();
}, function (_ref6) {
  var primaryColor = _ref6.theme.primaryColor;
  return primaryColor;
});
var ContactWrapper$1 = styled.div(_templateObject9$1());
var CheckBox = styled.input(_templateObject10$1());
var ContactInfo = styled.div(_templateObject11$1());
var SelectAll = styled.div(_templateObject12$1());
var SelectedContactCount = styled.span(_templateObject13$1());
var spin = keyframes(_templateObject14$1());
var Loadable = styled.div(_templateObject15$1(), function (props) {
  return props.width ? props.width + "px" : '50px';
}, function (props) {
  return props.width ? props.width + "px" : '50px';
}, function (_ref7) {
  var inverted = _ref7.inverted,
      primaryColor = _ref7.theme.primaryColor;
  return inverted ? '#fff' : primaryColor;
}, function (_ref8) {
  var inverted = _ref8.inverted,
      primaryColor = _ref8.theme.primaryColor;
  return inverted ? primaryColor : '#fff';
}, spin);
var SelectAllWrapper = styled.div(_templateObject16$1());

var Sidebar = function Sidebar() {
  var _useGlobal = useGlobal('sidebar'),
      sidebar = _useGlobal[0];

  var handleSidebar = useDispatch('SIDEBAR');

  var _useGlobal2 = useGlobal('DataFilters'),
      DataFilters = _useGlobal2[0];

  var _useGlobal3 = useGlobal('onConversationsPagination');

  var _useGlobal4 = useGlobal('onConversationArchiveChange'),
      onConversationArchiveChange = _useGlobal4[0];

  var _useGlobal5 = useGlobal('onConversationSearch'),
      onConversationSearch = _useGlobal5[0];

  var _useGlobal6 = useGlobal('searchButtonUrl'),
      searchButtonUrl = _useGlobal6[0];

  var _useGlobal7 = useGlobal('archivedOpenFilter'),
      archivedOpenFilter = _useGlobal7[0];

  var _useGlobal8 = useGlobal('archivedOpenFilterActive'),
      archivedOpenFilterActive = _useGlobal8[0];

  var _useGlobal9 = useGlobal('archivedOpenFilterDimmed'),
      archivedOpenFilterDimmed = _useGlobal9[0];

  var _useState = useState(false),
      archived = _useState[0],
      setArchived = _useState[1];

  var _useGlobal10 = useGlobal('text'),
      text = _useGlobal10[0];

  var _useGlobal11 = useGlobal('callLogs'),
      callLogs = _useGlobal11[0];

  var _useState2 = useState(''),
      query = _useState2[0],
      setQuery = _useState2[1];

  var _useGlobal12 = useGlobal('conversations'),
      conversations = _useGlobal12[0];

  var onSearch = useCallback(function (event, inputQuery) {
    onConversationSearch(inputQuery === undefined ? query : inputQuery);
  }, [query]);
  var onQueryChange = useCallback(function (event) {
    setQuery(event.target.value);

    if (!event.target.value) {
      onSearch(null, '');
    }
  }, [onSearch]);

  var handleSetArchived = function handleSetArchived(value) {
    setArchived(value);
    onConversationArchiveChange(value);
  };

  var renderArchivingToggle = function renderArchivingToggle() {
    return archivedOpenFilter && /*#__PURE__*/React.createElement(ArchivedOpenWrapper, {
      className: "archived-open-wrapper"
    }, /*#__PURE__*/React.createElement(OpenArchivedButton, {
      className: "open-button-wrapper",
      activeColor: archivedOpenFilterActive,
      dimmedColor: archivedOpenFilterDimmed,
      selected: false,
      onClick: function onClick() {
        return handleSetArchived(!archived);
      }
    }, archived ? text.openChats : text.archivedChats), /*#__PURE__*/React.createElement(OpenArchivedButton, {
      className: "archived-button-wrapper",
      activeColor: archivedOpenFilterActive,
      dimmedColor: archivedOpenFilterDimmed,
      selected: false,
      onClick: callLogs
    }, text.callLogs));
  };

  var renderArchiving = function renderArchiving() {
    return archivedOpenFilter && /*#__PURE__*/React.createElement(ArchivedOpenWrapper, {
      className: "archived-open-wrapper"
    }, /*#__PURE__*/React.createElement(OpenArchivedButton, {
      className: "open-button-wrapper",
      activeColor: archivedOpenFilterActive,
      dimmedColor: archivedOpenFilterDimmed,
      selected: !archived,
      onClick: function onClick() {
        return handleSetArchived(false);
      }
    }, text.openChats), /*#__PURE__*/React.createElement(OpenArchivedButton, {
      className: "archived-button-wrapper",
      activeColor: archivedOpenFilterActive,
      dimmedColor: archivedOpenFilterDimmed,
      selected: archived,
      onClick: function onClick() {
        return handleSetArchived(true);
      }
    }, text.archivedChats));
  };

  return /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      handleSidebar('hidden');
    }
  }, /*#__PURE__*/React.createElement(SidebarWrapper, {
    state: sidebar,
    className: "sidebar-wrapper"
  }, /*#__PURE__*/React.createElement(Fragment$1, null, console.log({
    callLogs: callLogs
  }), callLogs ? renderArchivingToggle() : renderArchiving(), /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(Search, {
    placeholder: text.searchConversations,
    onChange: onQueryChange,
    value: query,
    className: "search-bar-conversation"
  }), /*#__PURE__*/React.createElement(FooterButton, {
    style: {
      opacity: query.length > 0 ? 1 : 0.5
    },
    className: "search-button footer-button",
    onClick: onSearch
  }, conversations.loading ? /*#__PURE__*/React.createElement(Loadable, {
    width: 20
  }) : /*#__PURE__*/React.createElement("img", {
    src: searchButtonUrl || 'https://res.cloudinary.com/thewebops/image/upload/v1600766695/search_dopufh.png',
    alt: "search"
  })))), DataFilters && /*#__PURE__*/React.createElement(FiltersWrapper, null, DataFilters), /*#__PURE__*/React.createElement(ConversationList$1, null)));
};

var Sidebar$1 = React.memo(Sidebar);

var SecondDeviceLayout = function SecondDeviceLayout() {
  var _useGlobal = useGlobal('text'),
      text = _useGlobal[0];

  return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(WrongDevice, {
    className: "wrong-device"
  }, text.wrongDevice, /*#__PURE__*/React.createElement("button", {
    className: "go-back-button",
    onClick: function onClick() {
      history.back();
    }
  }, "Go Back")));
};

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  width: 30px;\n  margin-right: 20px;\n\n  transition: all 0.3s ease;\n\n  &:hover {\n    background-color: #afafaf;\n  }\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 30px;\n  height: 3px;\n  background-color: #0e1111;\n  margin: 5px 0;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledBar = styled.div(_templateObject$3());
var StyledBurgerIconWrapper = styled.div(_templateObject2$2());

var BurgerIcon = function BurgerIcon() {
  var _useGlobal = useGlobal('sidebar'),
      sidebar = _useGlobal[0];

  var _useGlobal2 = useGlobal('CustomMenuIcon'),
      CustomMenuIcon = _useGlobal2[0];

  var handleSidebar = useDispatch('SIDEBAR');
  var onClick = useCallback(function () {
    if (sidebar === 'active') handleSidebar('hidden');else handleSidebar('active');
  }, [sidebar]);
  return /*#__PURE__*/React.createElement(StyledBurgerIconWrapper, {
    onClick: onClick,
    className: "burger-icon"
  }, CustomMenuIcon ? /*#__PURE__*/React.createElement(CustomMenuIcon, null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledBar, null), /*#__PURE__*/React.createElement(StyledBar, null), /*#__PURE__*/React.createElement(StyledBar, null)));
};

var FooterUI = function FooterUI(_ref) {
  var onChangeFile = _ref.onChangeFile,
      onInputChange = _ref.onInputChange,
      inputValue = _ref.inputValue,
      preventEnterKeyPress = _ref.preventEnterKeyPress,
      onSend = _ref.onSend,
      inputRef = _ref.inputRef,
      disabled = _ref.disabled,
      disabledSend = _ref.disabledSend,
      _ref$allowFileUploads = _ref.allowFileUploads,
      allowFileUploads = _ref$allowFileUploads === void 0 ? true : _ref$allowFileUploads,
      loading = _ref.loading,
      onEmojiChange = _ref.onEmojiChange,
      useTextArea = _ref.useTextArea;

  var _useGlobal = useGlobal('acceptedFileTypes'),
      acceptedFileTypes = _useGlobal[0];

  var _useGlobal2 = useGlobal('messageDelivery'),
      messageDelivery = _useGlobal2[0];

  var _useGlobal3 = useGlobal('UploadFileButton'),
      UploadFileButton = _useGlobal3[0];

  var _useGlobal4 = useGlobal('placeholder'),
      placeholder = _useGlobal4[0];

  var _useGlobal5 = useGlobal('SendButton'),
      SendButton = _useGlobal5[0];

  var _useGlobal6 = useGlobal('text'),
      text = _useGlobal6[0];

  var _useState = useState(false),
      emoji = _useState[0],
      setEmoji = _useState[1];

  var _useGlobal7 = useGlobal('selectFirstConversation'),
      selectFirstConversation = _useGlobal7[0];

  var _useGlobal8 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal8[0];

  var conversation = useConversation(selectedConversation);

  var _useGlobal9 = useGlobal('disableSendingOnArchive'),
      disableSendingOnArchive = _useGlobal9[0];

  var onEmojiPress = function onEmojiPress() {
    setEmoji(!emoji);
  };

  var closeEmoji = function closeEmoji() {
    if (emoji) setEmoji(false);
  };

  var onEmoji = function onEmoji(event, emojiObject) {
    var value = "" + String.fromCodePoint(parseInt(emojiObject.unified, 16));
    onEmojiChange(value);
  };

  var onBlur = function onBlur(e) {
    if (!inputValue) window.scrollTo(0, 0);
  };

  var renderSendButton = function renderSendButton() {
    if (loading) return /*#__PURE__*/React.createElement(Loadable, {
      width: 20,
      inverted: true
    });
    if (SendButton) return /*#__PURE__*/React.createElement(SendButton, null);
    return text.send;
  };

  var renderUploadFileButton = function renderUploadFileButton() {
    if (messageDelivery.loading) return /*#__PURE__*/React.createElement(Loadable, {
      width: 20,
      inverted: true
    });
    if (UploadFileButton) return /*#__PURE__*/React.createElement(UploadFileButton, null);
    return /*#__PURE__*/React.createElement("img", {
      src: "https://res.cloudinary.com/thewebops/image/upload/v1600625100/upload_toftee.png"
    });
  };

  return (!disableSendingOnArchive || disableSendingOnArchive && !(conversation === null || conversation === void 0 ? void 0 : conversation.is_archived)) && /*#__PURE__*/React.createElement(FooterWrapper, {
    className: "footer-wrapper"
  }, /*#__PURE__*/React.createElement(FooterButton, {
    fixedHeight: selectFirstConversation,
    smallMargin: true,
    onClick: onEmojiPress,
    className: "footer-button emoji-button"
  }, "\uD83D\uDE03"), allowFileUploads && /*#__PURE__*/React.createElement("label", {
    htmlFor: "fileUpload"
  }, /*#__PURE__*/React.createElement(FileInput, {
    disabled: disabled,
    multiple: false,
    onChange: onChangeFile,
    id: "fileUpload",
    type: "file",
    accept: acceptedFileTypes
  }), /*#__PURE__*/React.createElement(FooterButton, {
    fixedHeight: selectFirstConversation,
    smallMargin: true,
    className: "footer-button file-upload",
    disabled: disabled
  }, renderUploadFileButton())), /*#__PURE__*/React.createElement(FooterInputWrapper, null, /*#__PURE__*/React.createElement(ChatInput, {
    placeholder: placeholder,
    ref: inputRef,
    onChange: onInputChange,
    value: inputValue,
    onKeyPress: preventEnterKeyPress,
    type: "text",
    as: useTextArea ? 'textarea' : 'input',
    onBlur: onBlur,
    rows: 2
  }), /*#__PURE__*/React.createElement(FooterButton, {
    as: "button",
    disabled: disabled || disabledSend,
    className: "footer-button send-button",
    onClick: onSend
  }, renderSendButton())), emoji && /*#__PURE__*/React.createElement(OutsideClickHandler, {
    display: "contents",
    onOutsideClick: closeEmoji
  }, /*#__PURE__*/React.createElement(EmojiWrapper, {
    active: emoji
  }, /*#__PURE__*/React.createElement(EmojiPicker, {
    disableAutoFocus: true,
    onEmojiClick: onEmoji
  }))));
};

var Footer = function Footer(_ref) {
  var currentlySelectedContacts = _ref.currentlySelectedContacts,
      removedContacts = _ref.removedContacts,
      allSelectedContacts = _ref.allSelectedContacts,
      allContacts = _ref.allContacts;
  var inputRef = useRef();

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useGlobal = useGlobal('broadcast'),
      broadcast = _useGlobal[0];

  var _useGlobal2 = useGlobal('broadcastUserList'),
      broadcastUserList = _useGlobal2[0];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var isAnyContactSelected = useMemo(function () {
    var isAnyAllSelected = broadcastUserList.reduce(function (accum, _ref2) {
      var value = _ref2.value;
      return accum || allSelectedContacts[value];
    }, false);
    if (isAnyAllSelected) return isAnyAllSelected;
    var areContactsSelected = broadcastUserList.reduce(function (accum, _ref3) {
      var value = _ref3.value;
      var contacts = currentlySelectedContacts[value];
      if (!contacts) return accum;
      var selected = Object.keys(contacts).filter(function (id) {
        var _removedContacts$valu;

        return !((_removedContacts$valu = removedContacts[value]) === null || _removedContacts$valu === void 0 ? void 0 : _removedContacts$valu[id]);
      });
      return accum || selected && selected.length;
    }, false);
    return areContactsSelected;
  }, [broadcastUserList, allSelectedContacts, currentlySelectedContacts, removedContacts]);

  var getRecipients = function getRecipients() {
    var getRecipientIds = function getRecipientIds(isAllSelected, key) {
      if (isAllSelected) return allContacts.reduce(function (accum, contact) {
        var _removedContacts$key;

        if (!((_removedContacts$key = removedContacts[key]) === null || _removedContacts$key === void 0 ? void 0 : _removedContacts$key[contact.id])) return [].concat(accum, [contact.id]);
        return accum;
      }, []);
      if (!currentlySelectedContacts[key]) return null;
      return Object.keys(currentlySelectedContacts[key]).filter(function (id) {
        var _removedContacts$key2;

        return !((_removedContacts$key2 = removedContacts[key]) === null || _removedContacts$key2 === void 0 ? void 0 : _removedContacts$key2[id]);
      });
    };

    var targetedParticipants = broadcastUserList.reduce(function (accum, _ref4) {
      var _ref5;

      var value = _ref4.value;
      var ids = getRecipientIds(allSelectedContacts[value], value);
      return _extends({}, accum, ids && ids.length && (_ref5 = {}, _ref5[value] = ids, _ref5));
    }, {});
    return targetedParticipants;
  };

  var sendBroadcast = function sendBroadcast(message) {
    var targetedParticipants = getRecipients();
    if (isEmpty_1(targetedParticipants) || !message) return false;
    setLoading(true);
    broadcast({
      message: message,
      targeted_participants: targetedParticipants
    }).then(function () {
      return setLoading(false);
    })["catch"](function () {
      return setLoading(false);
    });
    return true;
  };

  var onSend = function onSend() {
    var sent = sendBroadcast(inputValue);
    if (sent) setInputValue('');
  };

  var onChangeFile = function onChangeFile(event) {
    var files = event.target.files;
    Object.entries(files).forEach(function (_ref6) {
      var file = _ref6[1];
      sendBroadcast({
        file: file
      });
    });
    event.target.value = null;
    event.target.files = null;
  };

  var preventEnterKeyPress = function preventEnterKeyPress(event) {
    if (event.key === 'Enter') event.preventDefault();
  };

  var onInputChange = function onInputChange(event) {
    return setInputValue(event.target.value);
  };

  var onEmojiChange = function onEmojiChange(value) {
    setInputValue(function (prevValue) {
      return prevValue + " " + value;
    });
  };

  useKeyboard('Enter', onSend);
  return /*#__PURE__*/React.createElement(FooterWrapper$1, null, /*#__PURE__*/React.createElement(FooterUI, {
    onChangeFile: onChangeFile,
    onInputChange: onInputChange,
    preventEnterKeyPress: preventEnterKeyPress,
    inputValue: inputValue,
    inputRef: inputRef,
    onSend: onSend,
    disabled: !isAnyContactSelected,
    disabledSend: !inputValue,
    allowFileUploads: false,
    loading: loading,
    onEmojiChange: onEmojiChange,
    useTextArea: true
  }));
};

var ContactTab = function ContactTab(_ref) {
  var contactType = _ref.contactType,
      setSelected = _ref.setSelected,
      selectedContact = _ref.selectedContact,
      total = _ref.total,
      selectedContacts = _ref.selectedContacts,
      allSelected = _ref.allSelected,
      removedContacts = _ref.removedContacts;
  var label = contactType.label,
      value = contactType.value;

  var getCount = function getCount() {
    var removedCount = removedContacts ? Object.keys(removedContacts).length : 0;
    if (allSelected) return total - removedCount;
    return selectedContacts ? Object.keys(selectedContacts).length : 0;
  };

  return /*#__PURE__*/React.createElement(ContactTabTitle, {
    onClick: function onClick() {
      return setSelected(value);
    },
    isSelected: value === selectedContact
  }, label, total ? /*#__PURE__*/React.createElement(SelectedContactCount, null, getCount(), " / ", total) : '');
};

var Contact = function Contact(_ref) {
  var contact = _ref.contact,
      changeContactStatus = _ref.changeContactStatus,
      allSelected = _ref.allSelected;

  var _useGlobal = useGlobal('resolveUserImage'),
      resolveImageMessageURL = _useGlobal[0];

  var _useGlobal2 = useGlobal('resolveBroadcastContactName'),
      resolveBroadcastContactName = _useGlobal2[0];

  var _useGlobal3 = useGlobal('avatarPlaceHolder'),
      avatarPlaceHolder = _useGlobal3[0];

  var targetImage = resolveImageMessageURL(contact);

  var _useState = useState(false),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var onCheck = function onCheck(event) {
    var checked = event.target.checked;
    setIsChecked(checked);
    changeContactStatus(contact.id, checked);
  };

  useEffect(function () {
    if (allSelected === undefined) return;
    setIsChecked(allSelected);
  }, [allSelected]);
  return /*#__PURE__*/React.createElement(ContactWrapper$1, {
    className: "contact-wrapper"
  }, /*#__PURE__*/React.createElement(ContactInfo, null, /*#__PURE__*/React.createElement(SenderImage, {
    isConversationImage: true,
    src: targetImage || avatarPlaceHolder
  }), resolveBroadcastContactName(contact)), /*#__PURE__*/React.createElement(CheckBox, {
    checked: isChecked,
    onChange: onCheck,
    type: "checkbox"
  }));
};

var Contact$1 = memo$1(Contact);

var BroadcastModal = function BroadcastModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;

  var _useGlobal = useGlobal('text'),
      text = _useGlobal[0];

  var _useGlobal2 = useGlobal('onFetchContacts'),
      onFetchContacts = _useGlobal2[0];

  var _useGlobal3 = useGlobal('broadcastUserList'),
      broadcastUserList = _useGlobal3[0];

  var _useGlobal4 = useGlobal('broadcastUsers'),
      broadcastUsers = _useGlobal4[0];

  var _useState = useState$1({}),
      currentlySelectedContacts = _useState[0],
      setCurrentlySelectedContacts = _useState[1];

  var _useState2 = useState$1({}),
      allSelectedContacts = _useState2[0],
      setAllSelectedContacts = _useState2[1];

  var _useState3 = useState$1({}),
      removedContacts = _useState3[0],
      setRemovedContacts = _useState3[1];

  var _useState4 = useState$1(broadcastUserList === null || broadcastUserList === void 0 ? void 0 : broadcastUserList[0].value),
      selectedContactType = _useState4[0],
      setSelectedContactType = _useState4[1];

  var _useState5 = useState$1({}),
      tabTotals = _useState5[0],
      setTabTotals = _useState5[1];

  useEffect(function () {
    setTabTotals(function (totals) {
      var _extends2;

      return _extends({}, totals, (_extends2 = {}, _extends2[selectedContactType] = broadcastUsers.contacts.length, _extends2));
    });
  }, [broadcastUsers]);

  var setSelected = function setSelected(value) {
    setSelectedContactType(value);
  };

  useEffect(function () {
    onFetchContacts({
      broacastUser: selectedContactType
    });
  }, [selectedContactType]);
  useEffect(function () {
    setRemovedContacts({});
    setCurrentlySelectedContacts({});
    setAllSelectedContacts({});
  }, [isOpen]);

  var resetState = function resetState(checked) {
    var reset = function reset(current) {
      var _extends3;

      return _extends({}, current, (_extends3 = {}, _extends3[selectedContactType] = {}, _extends3));
    };

    setRemovedContacts(reset);
    if (checked) setCurrentlySelectedContacts(reset);
  };

  var changeContactStatus = useCallback(function (id, isChecked) {
    var nextState = _extends({}, currentlySelectedContacts);

    var nextStateRemoved = _extends({}, removedContacts);

    if (isChecked) {
      var _nextStateRemoved$sel, _extends4;

      (_nextStateRemoved$sel = nextStateRemoved[selectedContactType]) === null || _nextStateRemoved$sel === void 0 ? true : delete _nextStateRemoved$sel[id];
      nextState[selectedContactType] = _extends({}, nextState[selectedContactType], (_extends4 = {}, _extends4[id] = true, _extends4));
    } else {
      var _nextState$selectedCo, _extends5;

      (_nextState$selectedCo = nextState[selectedContactType]) === null || _nextState$selectedCo === void 0 ? true : delete _nextState$selectedCo[id];
      nextStateRemoved[selectedContactType] = _extends({}, nextStateRemoved[selectedContactType], (_extends5 = {}, _extends5[id] = true, _extends5));
    }

    setCurrentlySelectedContacts(function (current) {
      return _extends({}, current, nextState);
    });
    setRemovedContacts(function (current) {
      return _extends({}, current, nextStateRemoved);
    });
  }, [currentlySelectedContacts, selectedContactType, removedContacts]);

  var renderContactTabs = function renderContactTabs() {
    if (!selectedContactType) return /*#__PURE__*/React.createElement(ContactsWrapper, null, /*#__PURE__*/React.createElement(ContactTabTitle, null, text.contactsTitle));
    return /*#__PURE__*/React.createElement(ContactsWrapper, null, broadcastUserList.map(function (contactType) {
      return /*#__PURE__*/React.createElement(ContactTab, {
        setSelected: setSelected,
        selectedContact: selectedContactType,
        key: contactType.value,
        contactType: contactType,
        total: tabTotals[contactType.value],
        selectedContacts: currentlySelectedContacts[contactType.value],
        removedContacts: removedContacts[contactType.value],
        allSelected: allSelectedContacts[contactType.value]
      });
    }));
  };

  var onSelectAll = function onSelectAll(event) {
    var checked = event.target.checked;
    setAllSelectedContacts(function (current) {
      var _extends6;

      return _extends({}, current, (_extends6 = {}, _extends6[selectedContactType] = checked, _extends6));
    });
    resetState(checked);
  };

  var renderContacts = function renderContacts() {
    var _broadcastUsers$conta, _broadcastUsers$conta2;

    if (!((_broadcastUsers$conta = broadcastUsers.contacts) === null || _broadcastUsers$conta === void 0 ? void 0 : _broadcastUsers$conta.length)) return /*#__PURE__*/React.createElement(ContactsListWrapper$1, null, ' ', broadcastUsers.loading ? /*#__PURE__*/React.createElement(Loadable, null) : text.noContactsFound, ' ');
    return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(SelectAllWrapper, null, /*#__PURE__*/React.createElement(SelectAll, null, /*#__PURE__*/React.createElement("span", null, text.selectAll), /*#__PURE__*/React.createElement(CheckBox, {
      checked: allSelectedContacts[selectedContactType],
      onChange: onSelectAll,
      type: "checkbox"
    }))), /*#__PURE__*/React.createElement(ContactsListWrapper$1, null, (_broadcastUsers$conta2 = broadcastUsers.contacts) === null || _broadcastUsers$conta2 === void 0 ? void 0 : _broadcastUsers$conta2.map(function (contact) {
      return /*#__PURE__*/React.createElement(Contact$1, {
        key: contact.id,
        contact: contact,
        changeContactStatus: changeContactStatus,
        allSelected: allSelectedContacts[selectedContactType]
      });
    })));
  };

  return isOpen && /*#__PURE__*/React.createElement(ModalContainer, null, /*#__PURE__*/React.createElement(OutsideClickHandler, {
    display: "contents",
    onOutsideClick: onClose
  }, /*#__PURE__*/React.createElement(ContentWrapper, {
    className: "content-wrapper"
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement("span", null, text.broadcast)), renderContactTabs(), renderContacts(), /*#__PURE__*/React.createElement(Footer, {
    currentlySelectedContacts: currentlySelectedContacts,
    removedContacts: removedContacts,
    allSelectedContacts: allSelectedContacts,
    allContacts: broadcastUsers.contacts
  })))));
};

var BroadcastModal$1 = memo$1(BroadcastModal);

var GenericModal = function GenericModal(_ref) {
  var visible = _ref.visible,
      Child = _ref.child,
      data = _ref.data,
      onClose = _ref.onClose,
      closeIcon = _ref.closeIcon;

  var onBackdrop = function onBackdrop() {
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };

  return /*#__PURE__*/React.createElement(GenericModalWrapper, {
    isVisible: visible
  }, /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideClick: onBackdrop
  }, Child && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(ChildWrapper, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "child-wrapper-modal"
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onBackdrop,
    icon: closeIcon,
    className: "close-button-modal"
  }), /*#__PURE__*/React.createElement(Child, {
    data: data
  })))));
};

var HeaderBody = function HeaderBody() {
  var _useGlobal = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal[0];

  var _useGlobal2 = useGlobal('getIdFromConversation'),
      getIdFromConversation = _useGlobal2[0];

  var _useGlobal3 = useGlobal('onFetchContact'),
      onFetchContact = _useGlobal3[0];

  var _useGlobal4 = useGlobal('resetContact'),
      resetContact = _useGlobal4[0];

  var conversation = useConversation(selectedConversation);

  var _useGlobal5 = useGlobal('conversationNameInChat'),
      conversationNameInChat = _useGlobal5[0];

  var _useGlobal6 = useGlobal('arrowDownIcon'),
      ArrowDownIcon = _useGlobal6[0];

  var _useGlobal7 = useGlobal('arrowUpIcon'),
      ArrowUpIcon = _useGlobal7[0];

  var _useGlobal8 = useGlobal('enableConversationSearch'),
      enableConversationSearch = _useGlobal8[0];

  var _useGlobal9 = useGlobal('searchButtonChatUrl'),
      searchButtonChatUrl = _useGlobal9[0];

  var _useGlobal10 = useGlobal('conversationImageInChat'),
      conversationImageInChat = _useGlobal10[0];

  var _useGlobal11 = useGlobal('showImageinConversation'),
      showImageinConversation = _useGlobal11[0];

  var _useGlobal12 = useGlobal('users'),
      UserEntities = _useGlobal12[0].entities;

  var _useGlobal13 = useGlobal('text'),
      text = _useGlobal13[0];

  var _useGlobal14 = useGlobal('isBroadcastEnabled'),
      isBroadcastEnabled = _useGlobal14[0];

  var isSmall = useMedia('(max-width: 768px)');

  var _useGlobal15 = useGlobal('selectFirstConversation'),
      selectFirstConversation = _useGlobal15[0];

  var _useGlobal16 = useGlobal('UserInfoModalContent'),
      UserInfoModalContent = _useGlobal16[0];

  var _useGlobal17 = useGlobal('closeIcon'),
      closeIcon = _useGlobal17[0];

  var _useState = useState(false),
      isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _useState2 = useState(false),
      genericModalOpen = _useState2[0],
      setGenericModalOpen = _useState2[1];

  var _useGlobal18 = useGlobal('currentContact'),
      currentContact = _useGlobal18[0];

  var _useGlobal19 = useGlobal('lockIcon'),
      lockIcon = _useGlobal19[0];

  var _useGlobal20 = useGlobal('onCall'),
      onCall = _useGlobal20[0];

  var _useGlobal21 = useGlobal('videoIcon'),
      VideoIcon = _useGlobal21[0];

  var _useSearchBar = useSearchBar({}),
      handleDecrementIndex = _useSearchBar.handleDecrementIndex,
      handleIncrementIndex = _useSearchBar.handleIncrementIndex,
      handleSearch = _useSearchBar.handleSearch,
      searching = _useSearchBar.searching;

  var openModal = function openModal() {
    return setIsModalOpen(true);
  };

  var closeModal = function closeModal() {
    return setIsModalOpen(false);
  };

  var openGenericModal = function openGenericModal() {
    if (!currentContact && !currentContact(conversation)) {
      onFetchContact({
        id: getIdFromConversation(conversation)
      });
    }

    setGenericModalOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setGenericModalOpen(false);
    resetContact();
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GenericModal, {
    visible: genericModalOpen,
    data: currentContact(conversation) || currentContact,
    child: UserInfoModalContent,
    onClose: handleCloseModal,
    closeIcon: closeIcon
  }), /*#__PURE__*/React.createElement(HeaderWrapper, {
    className: "header-wrapper"
  }, isSmall && !selectFirstConversation && /*#__PURE__*/React.createElement(BurgerIcon, null), conversation && /*#__PURE__*/React.createElement("div", {
    className: "inner-header-wrapper"
  }, /*#__PURE__*/React.createElement(ImageNameSearchWrapper, {
    className: "image-name-search-wrapper"
  }, /*#__PURE__*/React.createElement(ImageNameWrapper, {
    className: "image-name-wrapper"
  }, showImageinConversation && /*#__PURE__*/React.createElement(ContactImage, {
    src: conversationImageInChat(conversation, UserEntities),
    className: "contact-image"
  }), /*#__PURE__*/React.createElement(ContactName, {
    onClick: openGenericModal,
    className: "contact-name"
  }, conversationNameInChat(conversation, UserEntities)), lockIcon && lockIcon()), enableConversationSearch && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(SearchBar, null, /*#__PURE__*/React.createElement(Search, {
    className: "search-bar-chat",
    onChange: handleSearch
  }), /*#__PURE__*/React.createElement(FooterButton, {
    className: "search-button-chat footer-button"
  }, !searching ? /*#__PURE__*/React.createElement("img", {
    src: searchButtonChatUrl || 'https://res.cloudinary.com/thewebops/image/upload/v1600766695/search_dopufh.png',
    alt: "search"
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    onClick: handleIncrementIndex
  }, /*#__PURE__*/React.createElement(ArrowUpIcon, null)), /*#__PURE__*/React.createElement("span", {
    onClick: handleDecrementIndex
  }, /*#__PURE__*/React.createElement(ArrowDownIcon, null)))))), onCall && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(CallChatButton, {
    className: "call-chat-button",
    onClick: onCall(conversation)
  }, /*#__PURE__*/React.createElement(VideoIcon, null)))), /*#__PURE__*/React.createElement(TypingIndicator, {
    conversation: selectedConversation
  })), isBroadcastEnabled && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(BroadcastModal$1, {
    isOpen: isModalOpen,
    onClose: closeModal
  }), /*#__PURE__*/React.createElement(BroadcastWrapper, null, /*#__PURE__*/React.createElement(FooterButton, {
    onClick: openModal,
    className: "footer-button"
  }, text.broadcast)))));
};

var HeaderBody$1 = memo(HeaderBody);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */

var now = function now() {
  return _root.Date.now();
};

var now_1 = now;
/** Error message constants. */

var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeMax = Math.max,
    nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber_1(wait) || 0;

  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time; // Start the timer for the trailing edge.

    timerId = setTimeout(timerExpired, wait); // Invoke the leading edge.

    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime; // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.

    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now_1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    } // Restart the timer.


    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined; // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;
var forbiden = ["", " "];

var validateInput = function validateInput(text) {
  return !forbiden.includes(text);
};

var Footer$1 = function Footer() {
  var inputRef = useRef();

  var _useGlobal = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal[0];

  var _useGlobal2 = useGlobal('onMessageSend'),
      onMessageSend = _useGlobal2[0];

  var _useFileReader = useFileReader(onMessageSend),
      onChangeFile = _useFileReader[0];

  var _useGlobal3 = useGlobal('onTypingChange'),
      onTypingChange = _useGlobal3[0];

  var isSmall = useMedia('(max-width: 768px)');

  var _useState = useState(false),
      typingStatus = _useState[0],
      setTypingStatus = _useState[1];

  var _useState2 = useState(''),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  useEffect(function () {
    setInputValue('');
  }, [selectedConversation]);
  var onSend = useCallback(function (event) {
    if (event.key === 'Enter' && (event.shiftKey || isSmall)) {
      addNewLineToTextArea();
      return;
    }

    onMessageSend(inputValue);
    setTypingStatus(false);
    onTypingChange(false);
    setInputValue('');
    autosize.destroy(inputRef.current);
    if (isSmall) window.scrollTo(0, 0);
  }, [inputValue, onTypingChange, isSmall]);

  var addNewLineToTextArea = function addNewLineToTextArea() {
    setInputValue(function (input) {
      return input + " \r\n";
    });
    if (inputRef.current) autosize.update(inputRef.current);
  };

  var onInputChange = useCallback(function (event) {
    autosize(inputRef.current);
    if (validateInput(event.target.value)) setInputValue(event.target.value);

    if (!typingStatus) {
      setTypingStatus(true);
      onTypingChange(true);
    }

    stopTyping();
  }, [typingStatus, onTypingChange]);

  var onEmojiChange = function onEmojiChange(value) {
    setInputValue(function (prevValue) {
      return prevValue + " " + value;
    });
  };

  var stopTyping = useCallback(debounce_1(function () {
    setTypingStatus(false);
    onTypingChange(false);
  }, 1500), [onTypingChange]);
  var preventEnterKeyPress = useCallback(function (event) {
    if (event.key === 'Enter') event.preventDefault();
  }, []);
  useEffect(function () {
    if (inputRef.current && !isSmall) inputRef.current.focus();
  }, [selectedConversation]);
  useKeyboard('Enter', onSend);
  return /*#__PURE__*/React.createElement(FooterUI, {
    onChangeFile: onChangeFile,
    onInputChange: onInputChange,
    inputValue: inputValue,
    preventEnterKeyPress: preventEnterKeyPress,
    onSend: onSend,
    inputRef: inputRef,
    onEmojiChange: onEmojiChange,
    useTextArea: true
  });
};

var useUser = function useUser(id) {
  var _useGlobal = useGlobal('users'),
      user = _useGlobal[0].entities[id];

  return user;
};

var Message = function Message(_ref) {
  var id = _ref.id,
      index = _ref.index,
      listRef = _ref.listRef;
  var message = useMessage(id);

  var _useGlobal = useGlobal('currentUser'),
      currentUser = _useGlobal[0];

  var _useGlobal2 = useGlobal('locale'),
      locale = _useGlobal2[0];

  var _useGlobal3 = useGlobal('isObserver'),
      isObserver = _useGlobal3[0];

  var _useGlobal4 = useGlobal('orientationPriority'),
      orientationPriority = _useGlobal4[0];

  var body = message.body,
      attachment = message.attachment,
      date = message.created_at,
      sender = message.sender,
      status = message.status;
  var orientation = useMemo(function () {
    if (isObserver) {
      return sender.includes(orientationPriority) ? 'sender' : 'receiver';
    }

    return sender === currentUser ? 'sender' : 'receiver';
  }, []);

  var _useSearch = useSearch({
    id: id,
    listRef: listRef
  }),
      isMarked = _useSearch.isMarked,
      ref = _useSearch.ref;

  var messageData = useMemo(function () {
    return {
      attachment: attachment,
      body: body,
      status: status
    };
  }, []);
  return (messageData.status ? messageData.status === "SUCCESS" : true) && /*#__PURE__*/React.createElement(MessageWrapper, {
    id: id,
    orientation: orientation,
    ref: ref
  }, /*#__PURE__*/React.createElement(MessageDataWrapper, {
    orientation: orientation
  }, /*#__PURE__*/React.createElement(Sender, {
    id: id,
    index: index
  }), /*#__PURE__*/React.createElement(MessageRowWrapper, {
    orientation: orientation
  }, /*#__PURE__*/React.createElement(MessageData, {
    orientation: orientation,
    className: "message-data-" + orientation
  }, isMarked ? /*#__PURE__*/React.createElement("mark", null, /*#__PURE__*/React.createElement(GenericMessage, {
    message: messageData
  })) : /*#__PURE__*/React.createElement(GenericMessage, {
    message: messageData
  })), /*#__PURE__*/React.createElement(MessageDate, {
    orientation: orientation,
    className: "message-date-" + orientation
  }, format(parseISO(date), 'p', {
    locale: locale
  })))));
};

var Sender = memo$1(function (_ref2) {
  var id = _ref2.id,
      index = _ref2.index;

  var _useGlobal5 = useGlobal('senderName'),
      senderName = _useGlobal5[0];

  var current = useMessage(id);
  var user = useUser(current.sender);

  var _useGlobal6 = useGlobal('currentUser'),
      currentUser = _useGlobal6[0];

  var _useGlobal7 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal7[0];

  var _useGlobal8 = useGlobal('resolveUserImage'),
      resolveUserImage = _useGlobal8[0];

  var getMessage = useMessageCallback();

  var _useConversation = useConversation(selectedConversation),
      messages = _useConversation.messages;

  var _useGlobal9 = useGlobal('users'),
      UserEntities = _useGlobal9[0].entities;

  var _useGlobal10 = useGlobal('avatarPlaceHolder'),
      avatarPlaceHolder = _useGlobal10[0];

  var hideSender = useCallback(function () {
    if (index === 0) return false;
    var previous = getMessage(messages[index - 1]);
    return (previous === null || previous === void 0 ? void 0 : previous.sender) === current.sender;
  }, [messages, index]);
  if (!user || current.sender === currentUser || hideSender()) return null;
  var type = user.type;
  return /*#__PURE__*/React.createElement(SenderInfo, {
    className: "sender-info"
  }, /*#__PURE__*/React.createElement(SenderImage, {
    src: resolveUserImage(user) || avatarPlaceHolder
  }), /*#__PURE__*/React.createElement(MessageName, null, senderName(current.sender, UserEntities), type && /*#__PURE__*/React.createElement(MessageSender, null, " \xB7 " + type)));
});
var Image = memo$1(function (_ref3) {
  var attachment = _ref3.attachment;

  var _useGlobal11 = useGlobal('resolveImageMessageURL'),
      resolveImageMessageURL = _useGlobal11[0];

  var attachments = resolveImageMessageURL(attachment);
  return /*#__PURE__*/React.createElement(ModalImage, {
    className: "small-image",
    small: attachments.medium,
    large: attachments.large,
    hideDownload: true
  });
});
var File = memo$1(function (_ref4) {
  var attachment = _ref4.attachment;
  var file = attachment.file,
      metadata = attachment.metadata;
  var linkSource = file.startsWith('http://') || file.startsWith('https://') ? file : "//" + file;
  return /*#__PURE__*/React.createElement("a", {
    href: linkSource,
    target: "_blank",
    className: "attachment-file-chat"
  }, ' ', metadata.filename);
});
var _linkifyOptions = {
  target: '_blank'
};
var RenderTextMessage = memo$1(function (_ref5) {
  var message = _ref5.message;
  var parsedMessage = parseEmojis(message.body);
  return /*#__PURE__*/React.createElement(Linkify, {
    properties: _linkifyOptions
  }, parsedMessage);
});
var GenericMessage = memo$1(function (_ref6) {
  var message = _ref6.message;

  if (!isEmpty_1(message === null || message === void 0 ? void 0 : message.attachment)) {
    if (message.attachment.type === 'image') return /*#__PURE__*/React.createElement(Image, {
      attachment: message.attachment
    });
    return /*#__PURE__*/React.createElement(File, {
      attachment: message.attachment
    });
  }

  return /*#__PURE__*/React.createElement(RenderTextMessage, {
    key: message.id,
    message: message
  });
});
var Message$1 = memo$1(Message);

var usePrevious = function usePrevious(value) {
  var ref = useRef$1();
  useEffect$1(function () {
    ref.current = value;
  });
  return ref.current;
};

var MessageList = function MessageList() {
  var _listRef$current, _listRef$current5;

  var endReach = useRef();
  var listRef = useRef();

  var _useGlobal = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal[0];

  var _useGlobal2 = useGlobal('onMessagesPagination'),
      onMessagesPagination = _useGlobal2[0];

  var _useGlobal3 = useGlobal('hasMoreMessages'),
      hasMoreMessages = _useGlobal3[0];

  var _useGlobal4 = useGlobal('showDropDownToChat'),
      showDropDownToChat = _useGlobal4[0];

  var _ref = useConversation(selectedConversation) || {},
      messages = _ref.messages;

  var _useState = useState(false),
      dropVisible = _useState[0],
      setDropVisible = _useState[1];

  var previousMessages = usePrevious(messages);
  useLayoutEffect(function () {
    scrollToBottom();
  }, [selectedConversation]);
  useLayoutEffect(function () {
    if (!previousMessages || !messages) return;

    if (previousMessages[previousMessages.length - 1] !== messages[messages.length - 1]) {
      scrollToBottom();
    }
  }, [messages, (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollHeight]);

  var handleScrollDropDown = function handleScrollDropDown() {
    var _listRef$current2, _listRef$current3;

    if (((_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.scrollHeight) - ((_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 ? void 0 : _listRef$current3.scrollTop) > 1000) {
      setDropVisible(true);
    } else {
      setDropVisible(false);
    }
  };

  useEffect(function () {
    var _listRef$current4;

    (_listRef$current4 = listRef.current) === null || _listRef$current4 === void 0 ? void 0 : _listRef$current4.scrollTo(0, 99999);
    scrollToBottom();
    listRef.current.addEventListener('scroll', handleScrollDropDown);
    return function () {
      return listRef.current.removeEventListener('scroll', handleScrollDropDown);
    };
  }, [(_listRef$current5 = listRef.current) === null || _listRef$current5 === void 0 ? void 0 : _listRef$current5.scrollHeight]);

  var scrollToBottom = function scrollToBottom() {
    if (listRef.current) listRef.current.scrollTo({
      top: listRef.current.scrollHeight,
      behavior: 'smooth'
    });
  };

  var onPaginationBegin = useCallback(function () {
    onMessagesPagination();
  }, [onMessagesPagination]);
  var getScrollParent = useCallback(function () {
    return listRef.current;
  }, []);
  return /*#__PURE__*/React.createElement(MessagesWrapper, {
    id: "message-list",
    className: "message-list",
    ref: listRef
  }, /*#__PURE__*/React.createElement(InfiniteScroll$1, {
    isReverse: true,
    useWindow: false,
    loader: /*#__PURE__*/React.createElement(Spinner, {
      key: "spinner"
    }),
    hasMore: !!hasMoreMessages,
    loadMore: onPaginationBegin,
    getScrollParent: getScrollParent,
    initialLoad: false,
    threshold: 150
  }, /*#__PURE__*/React.createElement(ListRender$1, {
    listRef: listRef.current
  }), showDropDownToChat && /*#__PURE__*/React.createElement(DropDownToChat, {
    className: "drop-down-to-chat",
    onClick: scrollToBottom,
    show: dropVisible
  }, "\u2193")), /*#__PURE__*/React.createElement("div", {
    ref: endReach
  }));
};

var ListRender$1 = memo$1(function (listRef) {
  var _useGlobal5 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal5[0];

  var _ref2 = useConversation(selectedConversation) || {},
      messages = _ref2.messages;

  return (messages === null || messages === void 0 ? void 0 : messages.map(function (id, index) {
    return /*#__PURE__*/React.createElement(Fragment$1, {
      key: id
    }, /*#__PURE__*/React.createElement(DateSeperator, {
      id: id,
      index: index
    }), /*#__PURE__*/React.createElement(Message$1, {
      key: id,
      id: id,
      index: index,
      listRef: listRef
    }));
  })) || null;
});
var DateSeperator = memo$1(function (_ref3) {
  var id = _ref3.id,
      index = _ref3.index;
  var message = useMessage(id);
  var getMessage = useMessageCallback();

  var _useGlobal6 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal6[0];

  var _useConversation = useConversation(selectedConversation),
      messages = _useConversation.messages;

  var _useGlobal7 = useGlobal('locale'),
      locale = _useGlobal7[0];

  var hideDateTitle = useCallback(function () {
    if (index === 0) return false;
    var current = parseISO(message.created_at);
    var previous = parseISO(getMessage(messages[index - 1]).created_at);
    return differenceInCalendarDays(current, previous) === 0;
  }, [index]);
  if (hideDateTitle()) return null;
  return /*#__PURE__*/React.createElement(DateTitleWrapper, {
    className: "date-title-wrapper"
  }, /*#__PURE__*/React.createElement(Seperator, {
    className: "separator"
  }), /*#__PURE__*/React.createElement(MessageDateTitle, {
    className: "message-date-title"
  }, formatRelative(parseISO(message.created_at), new Date(), {
    locale: locale
  })));
});
var MessageList$1 = memo$1(MessageList);

var Header = function Header() {
  var _useGlobal = useGlobal('HeaderComponent'),
      HeaderComponent = _useGlobal[0];

  var _useGlobal2 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal2[0];

  return /*#__PURE__*/React.createElement("div", null, HeaderComponent && selectedConversation && HeaderComponent);
};

var Header$1 = memo(Header);

var Body = function Body() {
  var _useGlobal = useGlobal('footer'),
      footer = _useGlobal[0];

  var _useGlobal2 = useGlobal('text'),
      text = _useGlobal2[0];

  var _useGlobal3 = useGlobal('header'),
      header = _useGlobal3[0];

  var _useGlobal4 = useGlobal('sidebar'),
      sidebar = _useGlobal4[0];

  var _useGlobal5 = useGlobal('useE2EE'),
      useE2EE = _useGlobal5[0];

  var _useGlobal6 = useGlobal('selectedConversation'),
      selectedConversation = _useGlobal6[0];

  var _useGlobal7 = useGlobal('currentConversationParticipantPublicKey'),
      currentConversationParticipantPublicKey = _useGlobal7[0];

  var _useGlobal8 = useGlobal('selectFirstConversation'),
      selectFirstConversation = _useGlobal8[0];

  var _useGlobal9 = useGlobal('conversationExtraComponent'),
      ExtraComponent = _useGlobal9[0];

  var conversation = useConversation(selectedConversation);
  var isSmall = useMedia('(max-width: 768px)');
  return /*#__PURE__*/React.createElement(BodyContainer, null, /*#__PURE__*/React.createElement(Header$1, null), /*#__PURE__*/React.createElement(BodyWrapper, {
    sidebar: sidebar,
    className: "body-wrapper"
  }, (conversation === null || conversation === void 0 ? void 0 : conversation.messages.length) === 0 && text.noMessage ? /*#__PURE__*/React.createElement(NoPublicKey, {
    className: "no-public-key"
  }, text.noMessage) : selectedConversation ? useE2EE && !currentConversationParticipantPublicKey ? /*#__PURE__*/React.createElement(NoPublicKey, {
    className: "no-public-key"
  }, text.noPublicKey) : /*#__PURE__*/React.createElement(Fragment$1, null, selectFirstConversation && /*#__PURE__*/React.createElement(ExtraComponent, {
    selectConversation: selectedConversation,
    conversation: conversation
  }), header && /*#__PURE__*/React.createElement(HeaderBody$1, null), /*#__PURE__*/React.createElement(MessageList$1, null), footer && /*#__PURE__*/React.createElement(Footer$1, null)) : isSmall ? null : /*#__PURE__*/React.createElement(Fragment$1, null, header && /*#__PURE__*/React.createElement(HeaderBody$1, null), !selectFirstConversation && /*#__PURE__*/React.createElement(EmptyHandler, null))));
};

var EmptyHandler = function EmptyHandler() {
  var _useGlobal10 = useGlobal('text'),
      text = _useGlobal10[0];

  return /*#__PURE__*/React.createElement(EmptyHandlerWrapper, {
    className: "empty-handler-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "empty-text"
  }, text.selectConversation));
};

var Body$1 = React.memo(Body);
var defaultText = {
  selectConversation: 'Select a conversation and start chatting now',
  searchConversations: 'Search conversations',
  send: 'Send',
  firstMessage: 'Be the first to send a message',
  sentAttachment: 'sent an attachment',
  isTyping: 'is typing',
  areTyping: 'are typing',
  writeMessage: 'Write your message',
  noPublicKey: 'This user has not yet initiated his chat. Please try again later',
  openChats: 'Open',
  archivedChats: 'Archived'
};
var chatStatus = {
  ok: "OK",
  newDevice: "NEW DEVICE",
  wrongDevice: "WRONG_DEVICE"
};

var _sidebar = function _sidebar(global, dispatch, sidebar) {
  return {
    sidebar: sidebar
  };
};

var _toggleSearchPrevious = function _toggleSearchPrevious(global) {
  return {
    searchDownToggle: !global.searchDownToggle
  };
};

var _toggleSearchNext = function _toggleSearchNext(global) {
  return {
    searchUpToggle: !global.searchUpToggle
  };
};

var ChatopsWeb = function ChatopsWeb(_ref) {
  var header = _ref.header,
      footer = _ref.footer,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'ltr' : _ref$direction,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? defaultText : _ref$text,
      selectedConversation = _ref.selectedConversation,
      currentUser = _ref.currentUser,
      currentContact = _ref.currentContact,
      conversations = _ref.conversations,
      messages = _ref.messages,
      users = _ref.users,
      hasMoreMessages = _ref.hasMoreMessages,
      hasMoreConversations = _ref.hasMoreConversations,
      broadcastUsers = _ref.broadcastUsers,
      messageDelivery = _ref.messageDelivery,
      getIdFromConversation = _ref.getIdFromConversation,
      onConversationClick = _ref.onConversationClick,
      onConversationsPagination = _ref.onConversationsPagination,
      onConversationArchiveChange = _ref.onConversationArchiveChange,
      onConversationSearch = _ref.onConversationSearch,
      onMessagesSearch = _ref.onMessagesSearch,
      onMessagesPagination = _ref.onMessagesPagination,
      onMessageSend = _ref.onMessageSend,
      onTypingChange = _ref.onTypingChange,
      conversationExtraComponent = _ref.conversationExtraComponent,
      _ref$disableSendingOn = _ref.disableSendingOnArchive,
      disableSendingOnArchive = _ref$disableSendingOn === void 0 ? false : _ref$disableSendingOn,
      _ref$archivedOpenFilt = _ref.archivedOpenFilter,
      archivedOpenFilter = _ref$archivedOpenFilt === void 0 ? false : _ref$archivedOpenFilt,
      _ref$archivedOpenFilt2 = _ref.archivedOpenFilterActive,
      archivedOpenFilterActive = _ref$archivedOpenFilt2 === void 0 ? 'white' : _ref$archivedOpenFilt2,
      _ref$archivedOpenFilt3 = _ref.archivedOpenFilterDimmed,
      archivedOpenFilterDimmed = _ref$archivedOpenFilt3 === void 0 ? 'black' : _ref$archivedOpenFilt3,
      _ref$senderName = _ref.senderName,
      senderName = _ref$senderName === void 0 ? function () {
    return '';
  } : _ref$senderName,
      _ref$conversationName = _ref.conversationName,
      conversationName = _ref$conversationName === void 0 ? function () {
    return '';
  } : _ref$conversationName,
      _ref$arrowDownIcon = _ref.arrowDownIcon,
      arrowDownIcon = _ref$arrowDownIcon === void 0 ? false : _ref$arrowDownIcon,
      _ref$arrowUpIcon = _ref.arrowUpIcon,
      arrowUpIcon = _ref$arrowUpIcon === void 0 ? false : _ref$arrowUpIcon,
      _ref$videoIcon = _ref.videoIcon,
      videoIcon = _ref$videoIcon === void 0 ? false : _ref$videoIcon,
      _ref$closeIcon = _ref.closeIcon,
      closeIcon = _ref$closeIcon === void 0 ? 'https://res.cloudinary.com/mohamedhossam/image/upload/v1639923457/cancel_ilmxpu.svg' : _ref$closeIcon,
      _ref$showImageinConve = _ref.showImageinConversation,
      showImageinConversation = _ref$showImageinConve === void 0 ? false : _ref$showImageinConve,
      _ref$enableConversati = _ref.enableConversationSearch,
      enableConversationSearch = _ref$enableConversati === void 0 ? false : _ref$enableConversati,
      _ref$conversationName2 = _ref.conversationNameInChat,
      conversationNameInChat = _ref$conversationName2 === void 0 ? function () {
    return '';
  } : _ref$conversationName2,
      _ref$conversationImag = _ref.conversationImageInChat,
      conversationImageInChat = _ref$conversationImag === void 0 ? function () {
    return '';
  } : _ref$conversationImag,
      _ref$hideChatOnSideba = _ref.hideChatOnSidebarOpen,
      hideChatOnSidebarOpen = _ref$hideChatOnSideba === void 0 ? false : _ref$hideChatOnSideba,
      _ref$searchButtonChat = _ref.searchButtonChatUrl,
      searchButtonChatUrl = _ref$searchButtonChat === void 0 ? false : _ref$searchButtonChat,
      _ref$showDropDownToCh = _ref.showDropDownToChat,
      showDropDownToChat = _ref$showDropDownToCh === void 0 ? false : _ref$showDropDownToCh,
      _ref$showConversation = _ref.showConversationTiming,
      showConversationTiming = _ref$showConversation === void 0 ? false : _ref$showConversation,
      _ref$conversationTime = _ref.conversationTime,
      conversationTime = _ref$conversationTime === void 0 ? function () {} : _ref$conversationTime,
      _ref$searchButtonUrl = _ref.searchButtonUrl,
      searchButtonUrl = _ref$searchButtonUrl === void 0 ? false : _ref$searchButtonUrl,
      _ref$resolveUserImage = _ref.resolveUserImage,
      resolveUserImage = _ref$resolveUserImage === void 0 ? function () {
    return {};
  } : _ref$resolveUserImage,
      _ref$resolveImageMess = _ref.resolveImageMessageURL,
      resolveImageMessageURL = _ref$resolveImageMess === void 0 ? function () {
    return {};
  } : _ref$resolveImageMess,
      _ref$resolveConversat = _ref.resolveConversationTargetImage,
      resolveConversationTargetImage = _ref$resolveConversat === void 0 ? function () {
    return '';
  } : _ref$resolveConversat,
      _ref$resolveBroadcast = _ref.resolveBroadcastContactName,
      resolveBroadcastContactName = _ref$resolveBroadcast === void 0 ? function () {
    return '';
  } : _ref$resolveBroadcast,
      _ref$CustomMenuIcon = _ref.CustomMenuIcon,
      CustomMenuIcon = _ref$CustomMenuIcon === void 0 ? false : _ref$CustomMenuIcon,
      _ref$UploadFileButton = _ref.UploadFileButton,
      UploadFileButton = _ref$UploadFileButton === void 0 ? null : _ref$UploadFileButton,
      _ref$SendButton = _ref.SendButton,
      SendButton = _ref$SendButton === void 0 ? null : _ref$SendButton,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$broadcast = _ref.broadcast,
      broadcast = _ref$broadcast === void 0 ? function () {
    return '';
  } : _ref$broadcast,
      locale = _ref.locale,
      isBroadcastEnabled = _ref.isBroadcastEnabled,
      onFetchContacts = _ref.onFetchContacts,
      onFetchContact = _ref.onFetchContact,
      resetContact = _ref.resetContact,
      broadcastUserList = _ref.broadcastUserList,
      _ref$uploads = _ref.uploads,
      uploads = _ref$uploads === void 0 ? {
    acceptedFileTypes: '.jpeg,.png,.jpg,.svg,.pdf,.docx,.csv,.xlsx'
  } : _ref$uploads,
      _ref$avatarPlaceHolde = _ref.avatarPlaceHolder,
      avatarPlaceHolder = _ref$avatarPlaceHolde === void 0 ? 'https://res.cloudinary.com/webopsv2/image/upload/v1636280162/images_raevqs.png' : _ref$avatarPlaceHolde,
      isObserver = _ref.isObserver,
      statusE2EE = _ref.statusE2EE,
      orientationPriority = _ref.orientationPriority,
      selectFirstConversation = _ref.selectFirstConversation,
      dataFilters = _ref.dataFilters,
      UserInfoModalContent = _ref.UserInfoModalContent,
      lockIcon = _ref.lockIcon,
      currentConversationParticipantPublicKey = _ref.currentConversationParticipantPublicKey,
      useE2EE = _ref.useE2EE,
      onCall = _ref.onCall,
      HeaderComponent = _ref.HeaderComponent,
      callLogs = _ref.callLogs;
  var acceptedFileTypes = uploads.acceptedFileTypes;

  var _useState = useState(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(null),
      messageSearched = _useState2[0],
      setMessageSearched = _useState2[1];

  var _useState3 = useState(0),
      currentMessageIndex = _useState3[0],
      setCurrentMessageIndex = _useState3[1];

  var handleChangeCurrentMessageIndex = function handleChangeCurrentMessageIndex(index) {
    if (index < messageSearched.length && index >= 0) {
      setCurrentMessageIndex(index);
    }
  };

  var setMessageFound = function setMessageFound(value) {
    setMessageSearched(value);
  };

  useEffect(function () {
    setTimeout(function () {
      setLoading(false);
    }, 0);
    setGlobal({
      sidebar: !selectFirstConversation
    });
  }, [selectFirstConversation]);
  useLayoutEffect(function () {
    locale = locale(defaultDateFNSLocale);
    setGlobal({
      acceptedFileTypes: acceptedFileTypes,
      conversationExtraComponent: conversationExtraComponent,
      conversationName: conversationName,
      conversationNameInChat: conversationNameInChat,
      conversationImageInChat: conversationImageInChat,
      showConversationTiming: showConversationTiming,
      searchButtonChatUrl: searchButtonChatUrl,
      searchButtonUrl: searchButtonUrl,
      showDropDownToChat: showDropDownToChat,
      conversationTime: conversationTime,
      messageSearched: messageSearched,
      setMessageFound: setMessageFound,
      currentMessageIndex: currentMessageIndex,
      hideChatOnSidebarOpen: hideChatOnSidebarOpen,
      archivedOpenFilter: archivedOpenFilter,
      archivedOpenFilterActive: archivedOpenFilterActive,
      archivedOpenFilterDimmed: archivedOpenFilterDimmed,
      placeholder: placeholder,
      SendButton: SendButton,
      UploadFileButton: UploadFileButton,
      arrowDownIcon: arrowDownIcon,
      arrowUpIcon: arrowUpIcon,
      videoIcon: videoIcon,
      CustomMenuIcon: CustomMenuIcon,
      enableConversationSearch: enableConversationSearch,
      showImageinConversation: showImageinConversation,
      getIdFromConversation: getIdFromConversation,
      lockIcon: lockIcon,
      conversations: conversations,
      currentUser: currentUser,
      currentContact: currentContact,
      closeIcon: closeIcon,
      footer: footer,
      hasMoreConversations: hasMoreConversations,
      disableSendingOnArchive: disableSendingOnArchive,
      hasMoreMessages: hasMoreMessages,
      header: header,
      locale: locale,
      messages: messages,
      onConversationClick: onConversationClick,
      onConversationSearch: onConversationSearch,
      onMessagesSearch: onMessagesSearch,
      onConversationsPagination: onConversationsPagination,
      onConversationArchiveChange: onConversationArchiveChange,
      onMessageSend: onMessageSend,
      onMessagesPagination: onMessagesPagination,
      onTypingChange: onTypingChange,
      resolveImageMessageURL: resolveImageMessageURL,
      handleChangeCurrentMessageIndex: handleChangeCurrentMessageIndex,
      resolveUserImage: resolveUserImage,
      resolveConversationTargetImage: resolveConversationTargetImage,
      resolveBroadcastContactName: resolveBroadcastContactName,
      selectedConversation: selectedConversation,
      senderName: senderName,
      broadcast: broadcast,
      text: text,
      users: users,
      isBroadcastEnabled: isBroadcastEnabled,
      onFetchContacts: onFetchContacts,
      onFetchContact: onFetchContact,
      resetContact: resetContact,
      broadcastUserList: broadcastUserList,
      broadcastUsers: broadcastUsers,
      avatarPlaceHolder: avatarPlaceHolder,
      isObserver: isObserver,
      statusE2EE: statusE2EE,
      orientationPriority: orientationPriority,
      selectFirstConversation: selectFirstConversation,
      messageDelivery: messageDelivery,
      DataFilters: dataFilters,
      UserInfoModalContent: UserInfoModalContent,
      currentConversationParticipantPublicKey: currentConversationParticipantPublicKey,
      useE2EE: useE2EE,
      onCall: onCall,
      HeaderComponent: HeaderComponent,
      callLogs: callLogs
    });
  }, [acceptedFileTypes, conversationExtraComponent, conversationName, conversationNameInChat, conversationImageInChat, showDropDownToChat, lockIcon, showConversationTiming, CustomMenuIcon, searchButtonChatUrl, hideChatOnSidebarOpen, conversationTime, handleChangeCurrentMessageIndex, currentMessageIndex, messageSearched, setMessageFound, arrowDownIcon, arrowUpIcon, videoIcon, searchButtonUrl, placeholder, SendButton, UploadFileButton, showImageinConversation, enableConversationSearch, getIdFromConversation, archivedOpenFilter, archivedOpenFilterActive, disableSendingOnArchive, archivedOpenFilterDimmed, conversations, currentUser, currentContact, closeIcon, footer, hasMoreConversations, hasMoreMessages, header, locale, messages, onConversationClick, onConversationSearch, onMessagesSearch, onConversationsPagination, onConversationArchiveChange, onMessageSend, onMessagesPagination, onTypingChange, resolveImageMessageURL, resolveUserImage, resolveConversationTargetImage, selectedConversation, senderName, resolveBroadcastContactName, text, isBroadcastEnabled, onFetchContacts, onFetchContact, resetContact, broadcastUserList, broadcastUsers, avatarPlaceHolder, broadcast, isObserver, statusE2EE, orientationPriority, selectFirstConversation, messageDelivery, dataFilters, UserInfoModalContent, currentConversationParticipantPublicKey, useE2EE, onCall, HeaderComponent, callLogs]);
  addReducer('SIDEBAR', _sidebar);
  addReducer('TOGGLE_SEARCH_NEXT', _toggleSearchNext);
  addReducer('TOGGLE_SEARCH_PREVIOUS', _toggleSearchPrevious);
  var providedTheme = useMemo(function () {
    return _extends({}, theme, {
      direction: direction
    });
  }, [theme, direction]);
  if (loading) return null;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: providedTheme
  }, /*#__PURE__*/React.createElement(View, null));
};

var View = memo(function () {
  var _useGlobal = useGlobal('sidebar'),
      sidebar = _useGlobal[0];

  var _useGlobal2 = useGlobal('statusE2EE'),
      statusE2EE = _useGlobal2[0];

  var _useGlobal3 = useGlobal('text');

  var _useGlobal4 = useGlobal('hideChatOnSidebarOpen'),
      hideChatOnSidebarOpen = _useGlobal4[0];

  var renderBody = function renderBody() {
    if (!hideChatOnSidebarOpen || sidebar === true || sidebar === 'hidden') return /*#__PURE__*/React.createElement(Body$1, null);
    return null;
  };

  return /*#__PURE__*/React.createElement(ChatWrapper, null, statusE2EE === chatStatus.wrongDevice ? /*#__PURE__*/React.createElement(SecondDeviceLayout, null) : /*#__PURE__*/React.createElement(Fragment$2, null, sidebar && /*#__PURE__*/React.createElement(Sidebar$1, null), renderBody()));
});
ChatopsWeb.propTypes = {
  sidebar: propTypes.oneOfType([propTypes.bool, propTypes.oneOf(['hidden', 'active'])]),
  footer: propTypes.bool,
  header: propTypes.bool,
  onConversationSearch: propTypes.func,
  onMessagesSearch: propTypes.func,
  onConversationInput: propTypes.func,
  onMessageSend: propTypes.func,
  onMessagesPagination: propTypes.func.isRequired,
  conversations: propTypes.shape({
    entities: propTypes.shape({}),
    ids: propTypes.array
  }),
  messages: propTypes.shape({
    entities: propTypes.shape({})
  }),
  users: propTypes.shape({
    entities: propTypes.shape({})
  }),
  onTypingChange: propTypes.func
};
ChatopsWeb.defaultProps = {
  sidebar: true,
  onConversationSearch: function onConversationSearch(value) {},
  onMessagesSearch: function onMessagesSearch(value) {},
  onMessageSend: function onMessageSend(value) {},
  onTypingChange: function onTypingChange() {},
  conversations: {
    entities: {},
    ids: []
  },
  messages: {
    entities: {}
  },
  users: {
    entities: {}
  },
  footer: true,
  header: true
};
var index = memo(ChatopsWeb);
export default index;